export const DEFAULT_POST_COLLECTION_RATIO = 4 / 5;
